import script from "./promotionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./promotionPopup.vue?vue&type=style&index=0&id=3e3b996a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e3b996a"]])

export default __exports__